import { ReactElement } from 'react';
import { useAddress } from '../../contexts/AddressContext';
import { formatAddressString } from '../../utils/address';
import { useMenuWithCart } from '../../contexts/MenuWithCart';
import styles from './WeeklyAddressChange.module.scss';

export function WeeklyAddressChange(): ReactElement {
  const { addresses } = useAddress();
  const { setDisplayChangeCartAddress, cartShippingAddressId } = useMenuWithCart();
  const cartAddress = addresses.find((a) => a.id === cartShippingAddressId);
  const formattedAddress = cartAddress ? formatAddressString(cartAddress) : '';

  return (
    <div className={styles.weekly_address_change_container}>
      <div className={styles.name_container}>
        {`Delivering to ${cartAddress?.first_name} ${cartAddress?.last_name}`}
      </div>
      <div className={styles.address_container}>
        <span>{formattedAddress}</span>
        <div
          role="button"
          tabIndex={0}
          onClick={() => setDisplayChangeCartAddress(true)}
          onKeyUp={(e) => e.key === 'Enter' && setDisplayChangeCartAddress(true)}
          className={styles.change_address_text}
        >
          Change Address
        </div>
      </div>
    </div>
  );
}
